import { unableToFetchData } from "../../assets/images";
import NoDataView from "./NoDataView";

interface InboxErrorProps {
  onRetry?: () => void;
}

/**
 * Error state for the conversation inbox — mirrors mobile Error component
 * wrapping NoData with the "unable to fetch" illustration and messaging.
 */
const InboxError = ({ onRetry }: InboxErrorProps) => (
  <NoDataView
    image={unableToFetchData}
    title="Unable to load chats"
    description="Something went wrong while loading your conversations. Please try again."
    onRetry={onRetry}
    retryLabel="Try again"
  />
);

export default InboxError;
